import { BASE_URL } from 'constants/api';
import { stringify } from 'query-string';
import actions from './index';

export const ACTIONS = {
  GET: 'DEMO_INCENTIVE_GET',
  GET_SUCCESS: 'DEMO_INCENTIVE_GET_SUCCESS',
  GET_FAILURE: 'DEMO_INCENTIVE_GET_FAILURE',
  PATCH: 'DEMO_INCENTIVE_PATCH',
  PATCH_SUCCESS: 'DEMO_INCENTIVE_PATCH_SUCCESS',
  PATCH_FAILURE: 'DEMO_INCENTIVE_PATCH_FAILURE',
  POST: 'DEMO_INCENTIVE_POST',
  POST_SUCCESS: 'DEMO_INCENTIVE_POST_SUCCESS',
  POST_FAILURE: 'DEMO_INCENTIVE_POST_FAILURE',
  INVALIDATE_ITEM: 'DEMO_INCENTIVE_INVALIDATE_ITEM',
};

export const get = actions.get(
  (teacher_id, query) =>
    `${BASE_URL}/teachers/${teacher_id}/demo-incentives?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const patch = actions.patch(
  demoIncentiveId => `${BASE_URL}/demo-incentive/${demoIncentiveId}`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);

export const post = actions.post(
  (teacher_id, query) => `${BASE_URL}/teachers/${teacher_id}/demo-incentives`,
  {
    PENDING: ACTIONS.POST,
    SUCCESS: ACTIONS.POST_SUCCESS,
    FAILURE: ACTIONS.POST_FAILURE,
  },
);

export const invalidateItem = (id, query) => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: {
      id,
      query,
    },
  });
};
